<template>
  <div>
    <template v-if="data.pack !== undefined">
      <template v-if="data.pack.length !== 0">
        <v-row no-gutters>
          <v-col cols="12" md="6">
            <BatteryDigitalPacks :data="itemsHead" :offset="0" :reversed="false" />
          </v-col>
          <v-col cols="12" md="6">
            <BatteryDigitalPacks :data="itemsTail" :offset="this.data.pack.length / 2" :reversed="true" />
          </v-col>
        </v-row>
      </template>
    </template>
  </div>
</template>

<script>
import BatteryDigitalPacks from "./BatteryDigitalPacks.vue";

export default {
  name: "BatteryDigitalSet",
  components: {
    BatteryDigitalPacks,
  },
  props: {
    data: {
      type: Object,
      require: true,
    },
  },
  computed: {
    itemsHead() {
      return this.data.pack ? this.data.pack.slice(0, Math.round(this.data.pack.length / 2)) : [];
      //return this.data.pack.length > 6 ? (this.data.pack ? this.data.pack.slice(0, Math.round(this.data.pack.length / 2)) : []) : this.data.pack;
    },
    itemsTail() {
      return this.data.pack ? this.data.pack.slice(Math.round(this.data.pack.length / 2)).reverse() : [];
      //return this.data.pack.length > 6 ? (this.data.pack ? this.data.pack.slice(Math.round(this.data.pack.length / 2)).reverse() : []) : [];
    },
  },
};
</script>

<style scoped></style>
